import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/fetch-duck";
import { ICarrierContactList } from "interfaces/carrier-contact";
const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess", "onFailure"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "FETCH_LIST_CARRIER_CONTACT_" }
);

export interface FetchListCarrierContactState extends IState {
  data: ICarrierContactList | null;
}

export interface FetchListCarrierContactSuccess extends ISuccessAction {
  data: ICarrierContactList 
}

const INITIAL_STATE: FetchListCarrierContactState = {
  data: null,
  loading: false,
  error: null,
};

const request = (state: FetchListCarrierContactState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: FetchListCarrierContactState, action: ISuccessAction) =>
  update(state, {
    data: { $set: action.data as ICarrierContactList },
    loading: { $set: false },
  });

const failure = (state: FetchListCarrierContactState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const fetchListCarrierContact = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const FetchListCarrierContactTypes = Types;
export const FetchListCarrierContactActions = Creators;
